import React from 'react';
import TituloMuroPlacaTipoMarmol from '../components/sections/MuroPlacaTipoMarmol/TituloPlacaTipoMarmol';
import IntroPlacaTipoMarmol from '../components/sections/MuroPlacaTipoMarmol/IntroPlacaTipoMarmol';
import AplicacionesPlacaTipoMarmol from '../components/sections/MuroPlacaTipoMarmol/AplicacionesPlacaTipoMarmol';
import CaracteristicasPlacaTipoMarmol from '../components/sections/MuroPlacaTipoMarmol/CaracteristicasPlacaTipoMarmol';
import FormularioContactoTipoMarmol from '../components/sections/MuroPlacaTipoMarmol/FormularioContactoTipoMarmol';
// Componentes de Placa de Rollo
import SelectorProductoPlaca from '../components/sections/MuroPlacaTipoMarmol/SelectorProductoPlaca';
import IntroPlacaRollo from '../components/sections/MuroPlacaTipoMarmol/IntroPlacaRollo';
import ModelosPlacaRollo from '../components/sections/MuroPlacaTipoMarmol/ModelosPlacaRollo';
import VentajasRollo from '../components/sections/MuroPlacaTipoMarmol/VentajasRollo';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer'; 

const MuroPlacaTipoMarmolPage = () => {
  return (
    <div>
      <Header />
        <TituloMuroPlacaTipoMarmol />  
        <SelectorProductoPlaca /> 
        
        {/* Placas Rigidas */}
        <IntroPlacaTipoMarmol /> 
        <AplicacionesPlacaTipoMarmol /> 
        <CaracteristicasPlacaTipoMarmol /> 
        {/* Placas Rollo */}
        <IntroPlacaRollo />
        <ModelosPlacaRollo />

        <FormularioContactoTipoMarmol /> 
      <Footer />
    </div>
  );
};

export default MuroPlacaTipoMarmolPage;
